import { ShiftTypeTranslationKeys } from '../../features/ShiftFilters/ShiftFilters/ShiftTypeFilter/ShiftTypeFilterTypes';
import { UnavailableShiftTranslationKeys } from '../../features/ShiftFilters/ShiftFilters/UnavailableShiftFilter/UnavailableShiftFilterTypes';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '../../hooks/useLocalStorage/useLocalStorage';
export var legacyFilterKey = 'state';
export function convertLegacyFilter(oldFilter, t, locationNameToIdMap) {
    var _a;
    var _b, _c, _d, _e;
    if (!oldFilter || !oldFilter.filterState) {
        return undefined;
    }
    var newFilter = {
        location: {},
        shiftType: {},
        unavailable: {},
        shiftTime: {},
        jobType: {}
    };
    var _f = oldFilter.filterState, oldLocationFilter = _f.locationFilters, oldJobTypeFilter = _f.jobs, oldUnavailabilityFilter = _f.unavailabilities, oldShiftTimeFilter = _f.shiftTimeRange, oldShiftTypeFilter = _f.surgePay;
    // map locations -- we used names before but now we want to use ID's
    for (var _i = 0, _g = Object.entries(oldLocationFilter || {}); _i < _g.length; _i++) {
        var _h = _g[_i], locationName = _h[0], value = _h[1];
        var locationId = locationNameToIdMap.get(locationName);
        if (locationId) {
            newFilter.location[locationId] = value;
        }
        else {
            /* log an error/warn? */
        }
    }
    // map shiftType -- uses skill from shift opportunity
    for (var _j = 0, _k = Object.entries(oldJobTypeFilter || {}); _j < _k.length; _j++) {
        var _l = _k[_j], skill = _l[0], value = _l[1];
        newFilter.jobType[skill] = value;
    }
    // map unavailable filters -- these are using translated keys in storage
    var translatedUnavailabilityKeys = {
        SHOW_ALL_UNAVAILABLE: 'all',
        EXCEEDS_HOURS_CAP: t(UnavailableShiftTranslationKeys.EXCEEDS_HOURS_CAP),
        OVERLAPS_WITH_SCHEDULE: t(UnavailableShiftTranslationKeys.OVERLAPS_WITH_SCHEDULE)
    };
    newFilter.unavailable = (_a = {},
        _a[UnavailableShiftTranslationKeys.SHOW_ALL_UNAVAILABLE] = (_b = oldUnavailabilityFilter[translatedUnavailabilityKeys.SHOW_ALL_UNAVAILABLE]) !== null && _b !== void 0 ? _b : false,
        _a[UnavailableShiftTranslationKeys.EXCEEDS_HOURS_CAP] = (_c = oldUnavailabilityFilter[translatedUnavailabilityKeys.EXCEEDS_HOURS_CAP]) !== null && _c !== void 0 ? _c : false,
        _a[UnavailableShiftTranslationKeys.OVERLAPS_WITH_SCHEDULE] = (_d = oldUnavailabilityFilter[translatedUnavailabilityKeys.OVERLAPS_WITH_SCHEDULE]) !== null && _d !== void 0 ? _d : false,
        _a);
    // map shiftTime -- simply need to parse the stored time string
    newFilter.shiftTime.startTime = parseStoredTime(oldShiftTimeFilter.start);
    newFilter.shiftTime.endTime = parseStoredTime(oldShiftTimeFilter.end);
    // map jobType -- these are currently using some fixed keys (surgePay in legacy)
    newFilter.shiftType[ShiftTypeTranslationKeys.ONLY_WITH_PREMIUM] =
        (_e = oldShiftTypeFilter.surgePay) !== null && _e !== void 0 ? _e : false;
    return newFilter;
}
function parseStoredTime(timeString) {
    if (!timeString) {
        return undefined;
    }
    // try with am/pm first
    var parsedWithMeridiem = DateTime.fromFormat(timeString, 't');
    if (!!parsedWithMeridiem && parsedWithMeridiem.isValid) {
        return parsedWithMeridiem;
    }
    // try 24 hour
    var parsed24Hour = DateTime.fromFormat(timeString, 'T');
    if (!!parsed24Hour && parsed24Hour.isValid) {
        return parsed24Hour;
    }
    return undefined;
}
export var useLegacyFilters = function (props) {
    var t = useTranslation().t;
    var legacyLocalStorage = useLocalStorage({
        key: legacyFilterKey,
        employeeId: props.employeeId
    });
    var load = function () {
        return convertLegacyFilter(legacyLocalStorage === null || legacyLocalStorage === void 0 ? void 0 : legacyLocalStorage.load(), t, props.locationNameToIdMap);
    };
    return {
        load: load
    };
};
